import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/solid";

const Pagination = forwardRef(
  (
    {
      pages = 10,
      setPageNumber,
    }: {
      pages: any;
      setPageNumber: any;
    },
    ref?
  ) => {
    const numberOfPages: any = [];

    const [currentButton, setCurrentButton] = useState<any>(1);
    const [arrOfCurrButtons, setArrOfCurrButtons] = useState([]);
    const [totalPages, setTotalPages] = useState<number>(0);

    useEffect(() => {
      let tempNumberOfPages: any = [...arrOfCurrButtons];
      for (let i = 1; i <= pages; i++) {
        numberOfPages.push(i);
      }
      const dotsInitial = "...";
      const dotsLeft = "... ";
      const dotsRight = " ...";

      if (numberOfPages.length < 6) {
        tempNumberOfPages = numberOfPages;
      } else if (currentButton >= 1 && currentButton <= 3) {
        tempNumberOfPages = [1, 2, 3, 4, dotsInitial, numberOfPages.length];
      } else if (currentButton === 4) {
        const sliced = numberOfPages.slice(0, 5);
        tempNumberOfPages = [...sliced, dotsInitial, numberOfPages.length];
      } else if (
        currentButton > 4 &&
        currentButton < numberOfPages.length - 2
      ) {
        const sliced1 = numberOfPages.slice(currentButton - 2, currentButton);
        const sliced2 = numberOfPages.slice(currentButton, currentButton + 1);
        tempNumberOfPages = [
          1,
          dotsLeft,
          ...sliced1,
          ...sliced2,
          dotsRight,
          numberOfPages.length,
        ];
      } else if (currentButton > numberOfPages.length - 3) {
        const sliced: any = numberOfPages.slice(numberOfPages.length - 4);
        tempNumberOfPages = [1, dotsLeft, ...sliced];
      } else if (currentButton === dotsInitial) {
        setCurrentButton(arrOfCurrButtons[arrOfCurrButtons.length - 3] + 1);
      } else if (currentButton === dotsRight) {
        setCurrentButton(arrOfCurrButtons[3] + 2);
      } else if (currentButton === dotsLeft) {
        setCurrentButton(arrOfCurrButtons[3] - 2);
      }

      setArrOfCurrButtons(tempNumberOfPages);
      setPageNumber(currentButton);
      setTotalPages(numberOfPages.length);
    }, [currentButton, pages]);

    useImperativeHandle(ref, () => ({
      onReset() {
        setCurrentButton(1);
        setPageNumber(1);
      },
    }));

    return (
      <div className="bg-white py-3 flex items-center justify-between border-t border-gray-200 rounded ">
        <div className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px dark:text-white	">
          <div
            className={`${currentButton === 1 ? "cursor-not-allowed" : ""} `}
          >
            <a
              className={`${
                currentButton === 1 ? "pointer-events-none" : ""
              } z-10   relative inline-flex items-center px-4 py-2 border text-sm font-medium hover:bg-primary-color hover:text-white dark:text-white`}
              onClick={() =>
                setCurrentButton((prev) => (prev <= 1 ? prev : prev - 1))
              }
            >
              <ChevronLeftIcon className="w-5 " />
            </a>
          </div>
          {arrOfCurrButtons
            .filter(
              (item, index, arr) =>
                typeof item !== "number" || arr.indexOf(item) === index
            )
            .map((item, index) => {
              return (
                <a
                  key={index}
                  className={`${
                    currentButton === item
                      ? "active z-10 text-white bg-primary-color dark:text-white hover:bg-secondary-color"
                      : ""
                  } z-10  relative inline-flex items-center px-4 py-2 border text-sm font-medium hover:bg-secondary-color hover:text-white`}
                  onClick={() => setCurrentButton(item)}
                >
                  {item}
                </a>
              );
            })}
          <div
            className={`${
              currentButton === totalPages ? "cursor-not-allowed" : ""
            } `}
          >
            <a
              className={`${
                currentButton === totalPages ? "pointer-events-none" : ""
              } z-10  relative inline-flex items-center px-4 py-2 border text-sm font-medium hover:bg-secondary-color hover:text-white dark:text-white`}
              onClick={() =>
                setCurrentButton((prev) =>
                  prev >= totalPages ? prev : prev + 1
                )
              }
            >
              <ChevronRightIcon className="w-5" />
            </a>
          </div>
        </div>
      </div>
    );
  }
);

Pagination.displayName = "Pagination";

export default Pagination;
